import { z } from 'zod';
export const AnalyticsTimestampSchema = z.iso
    .datetime({ offset: true })
    .regex(/^(?!.*\.\d{4})/, 'Datetime bounds support at most millisecond precision')
    .describe('ISO 8601 timestamp with Z or an explicit offset and at most millisecond precision.');
//# sourceMappingURL=timestamp.js.map